import React from 'react';

import Banner from './Banner';
import { CUSTOMER_SERVICE_LINK } from '../../common/navigation/navigation';

const UnsupportedDeviceBanner = () => (
    <Banner isWarning>
        <div>
            You are using an outdated operating system. For assistance, please contact{' '}
            <a href={CUSTOMER_SERVICE_LINK} rel="noopener noreferrer" target="_blank">
                Amplify Customer Services.
            </a>
        </div>
    </Banner>
);

export default UnsupportedDeviceBanner;
